import styles from './styles.module.scss';

const GrayRingLoader = (props: any) => {
  return <div style={{margin: props.margin || ''}} className={styles.loader} />;
};

export default GrayRingLoader;
